import { PageProcessEventLogEntryDTO, ProcessLogEventType, SortableProcessEventLogField } from '@iota/inh-core-v1-management-client';
import { createAction, props } from '@ngrx/store';

export const LoadProcessEventLogs = createAction(
    '[ProcessEventLog] LoadProcessEventLogs',
    props<{
        eventTypes?: ProcessLogEventType[];
        from?: string;
        to?: string;
        page?: number;
        pageSize?: number;
        sortingField?: SortableProcessEventLogField;
        sortingAscending?: boolean;
    }>()
);
export const LoadProcessEventLogsSuccess = createAction(
    '[ProcessEventLog] LoadProcessEventLogsSuccess',
    props<{ page: PageProcessEventLogEntryDTO }>()
);
export const LoadProcessEventLogsFailure = createAction('[ProcessEventLog] LoadProcessEventLogsFailure', props<{ error: any }>());

export const DownloadProcessingReport = createAction('[ProcessEventLog] DownloadProcessingReport', props<{ eventLogId: string }>());
export const DownloadProcessingReportSuccess = createAction('[ProcessEventLog] DownloadProcessingReportSuccess');
export const DownloadProcessingReportFailure = createAction('[ProcessEventLog] DownloadProcessingReportFailure', props<{ error: any }>());
